(ns humbleai.belt.dom
  "Simple DOM and React helpers")

;; DOM

(defn ->value
  "Returns the non-empty string value of a field event"
  [event]
  (-> (.. event -target -value)
      (not-empty)))

(defn stop
  "Stop event propagation and default behaviour"
  [event]
  (.stopPropagation event)
  (.preventDefault event))

(defn bubbled-event?
  "Has the event bubbled up the DOM"
  [event]
  (not= (.-target event)
        (.-currentTarget event)))

(defn sleep
  "A way to simulate a blocking call in JS (via Promise chaining).
   Use it like so:
   (-> (sleep 1000)
       (.then (fn []...))
       (.then (fn []...))
       ...)"
  [ms]
  (js/Promise.
   (fn [resolve]
     (js/setTimeout resolve ms))))

;; React

(defn focus-input
  "Move focus to a React input ref"
  [input-ref]
  (some-> input-ref .-current .focus))

(defn select-input
  "Select the text of a React input ref"
  [input-ref]
  (some-> input-ref .-current .select))
